import {Hal} from './hal.model';

export class CustomActionHal extends Hal {
  name: string;

  constructor(data: any) {
    super(data);
    this.name = data.name;
  }
}

export class CustomActionCollectionHal extends Hal {
  _embedded?: { customActions: CustomActionHal[] };

  constructor(data: any) {
    super(data);
    if (data._embedded?.customActions) {
      this._embedded = {
        customActions: data._embedded.customActions.map((a: any) => new CustomActionHal(a))
      };
    }
  }
}
